export const CITATIONS_API_PATHS = {
    refineries: 'api/v1/refineries',
    units: 'units',
    runs: 'runs',
    citations: 'citations',
    manifest: 'manifest',
    assetTimeline: 'asset-timeline',
    assetDetails: 'asset-details',
    sourceFile: 'source'
} as const;

/** Blob container holding every citation source; fixed across all runs. */
export const CITATIONS_SOURCE_CONTAINER = 'produced';
